let cleanup = () => {};

function initializeHeroSliders() {
  cleanup();
  const controller = new AbortController();
  const { signal } = controller;
  const groups = [];
  const heroes = [...document.querySelectorAll('[data-hero-slider-group]')];
  for (const hero of heroes) {
    const section = hero.closest('.shopify-section');
    if (!section || getComputedStyle(section).display === 'none') continue;
    const previous = groups.at(-1);
    if (previous && previous.key === hero.dataset.heroSliderGroup && previous.slides.at(-1).section.nextElementSibling === section) {
      previous.slides.push({ hero, section });
    } else {
      groups.push({ key: hero.dataset.heroSliderGroup, slides: [{ hero, section }] });
    }
  }
  const controls = [];
  const timers = [];
  for (const { slides } of groups) {
    if (slides.length < 2) continue;
    let current = 0;
    const dots = [];
    const autoplay = slides[0].hero.dataset.sliderAutoplay === 'true';
    const interval = Math.max(3, Number(slides[0].hero.dataset.sliderInterval) || 5) * 1000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reducedMotion.matches;
    let hovered = false;
    let focused = false;
    let timer;
    const stop = () => clearTimeout(timer);
    timers.push(stop);
    function schedule() {
      stop();
      if (autoplay && !paused && !hovered && !focused && !document.hidden && !window.Shopify?.designMode) {
        timer = setTimeout(() => select(current + 1), interval);
      }
    }
    document.addEventListener('visibilitychange', schedule, { signal });
    reducedMotion.addEventListener('change', event => {
      paused = event.matches;
      schedule();
    }, { signal });
    function select(index, focus = false) {
      const old = slides[current];
      current = (index + slides.length) % slides.length;
      slides.forEach(({ hero, section }, i) => {
        section.classList.toggle('hero-slider-inactive', i !== current);
        hero.setAttribute('data-slider-ready', '');
        section.inert = i !== current;
        if (i !== current) hero.querySelectorAll('video').forEach(video => video.pause());
      });
      dots.forEach(({ button, index }) => {
        button.setAttribute('aria-current', String(index === current));
      });
      if (old !== slides[current]) {
        slides[current].hero.querySelectorAll('video[autoplay]').forEach(video => {
          if (getComputedStyle(video.parentElement).display !== 'none') video.play().catch(() => {});
        });
      }
      schedule();
      if (focus) slides[current].hero.querySelector('.hero-slider-controls button[aria-current="true"]').focus({ preventScroll: true });
    }
    slides.forEach(({ hero, section }) => {
      const nav = document.createElement('nav');
      nav.className = 'hero-slider-controls';
      nav.setAttribute('aria-label', hero.dataset.sliderLabel);
      const addButton = (label, text, action) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', label);
        button.textContent = text;
        button.addEventListener('click', action, { signal });
        nav.append(button);
        return button;
      };
      slides.forEach((slide, index) => {
        const button = addButton(`${hero.dataset.sliderSlide} ${index + 1} / ${slides.length}`, '', () => select(index, true));
        button.className = 'hero-slider-dot';
        dots.push({ button, index });
      });
      hero.addEventListener('mouseenter', () => { hovered = true; stop(); }, { signal });
      hero.addEventListener('mouseleave', () => { hovered = false; schedule(); }, { signal });
      hero.addEventListener('focusin', () => { focused = true; stop(); }, { signal });
      hero.addEventListener('focusout', event => {
        if (!hero.contains(event.relatedTarget)) { focused = false; schedule(); }
      }, { signal });
      hero.append(nav);
      controls.push(nav);
      let start;
      hero.addEventListener('touchstart', event => {
        start = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true, signal });
      hero.addEventListener('touchend', event => {
        if (!start) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        start = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) select(current + (dx < 0 ? 1 : -1));
      }, { passive: true, signal });
      hero.addEventListener('touchcancel', () => { start = null; }, { signal });
      document.addEventListener('shopify:section:select', event => {
        if (event.target === section) select(slides.findIndex(slide => slide.section === section));
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        if (section.contains(event.target)) select(slides.findIndex(slide => slide.section === section));
      }, { signal });
    });
    select(0);
  }
  cleanup = () => {
    controller.abort();
    timers.forEach(stop => stop());
    controls.forEach(control => control.remove());
    heroes.forEach(hero => {
      const section = hero.closest('.shopify-section');
      section?.classList.remove('hero-slider-inactive');
      if (section) section.inert = false;
    });
  };
}

let pending;
function scheduleInitialize() {
  clearTimeout(pending);
  pending = setTimeout(initializeHeroSliders, 0);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleInitialize, { once: true });
else scheduleInitialize();
for (const event of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) {
  document.addEventListener(event, scheduleInitialize);
}
window.matchMedia('(max-width: 749px)').addEventListener('change', scheduleInitialize);
